import React from "react";
import PropTypes from "prop-types";
import { getCursorPosition } from "../../../utils/cursorPosition";

export class Input extends React.Component {

  state = {
    cursorPosition: 0,
    userInput: ''
  };

  handleOnChange = (event) => {
    const { input } = this.props;
    if (input.onChange === undefined) {
      return;
    }
    if (this.props.type !== 'email') {
      this.setState({
        cursorPosition: event.target.selectionEnd,
        userInput: event.target.value
      });
    }

    input.onChange(event);
  };

  setCursorPosition = () => {
    if (this.ref && this.ref.value && this.ref.value !== "" && this.ref.type !== 'email') {
      const cursorPosition = getCursorPosition(String(this.state.userInput), String(this.ref.value), this.state.cursorPosition);

      if (this.ref.selectionEnd !== cursorPosition || this.ref.selectionStart !== cursorPosition) {
        this.ref.setSelectionRange(cursorPosition, cursorPosition);
      }
    }
  };

  isDirty = () => {
    const { input, meta } = this.props;
    return input.value || meta.active;
  };

  componentDidUpdate = () => {
    this.setCursorPosition();
  };

  render = () => {
    const { input, meta, htmlAttributes, styles } = this.props;
    const { name } = input;
    let inputStyles = ["form-control"];
    const parentDivStyles = ["form-group"];
    const ariaDescription = `Barclaycard CL Apply Application-sr-description`;

    if (styles) {
      inputStyles = inputStyles.concat(styles.input);
    }

    let ariaDescriptionExists = false;
    let errorMarkup = null;
    let smallDisclosureMarkup = null;

    if (meta.touched && meta.error && !meta.active) {
      inputStyles.push("is-invalid");
      parentDivStyles.push("is-invalid-field");
      ariaDescriptionExists = true;
      errorMarkup = (<div id={ariaDescription} className="invalid-feedback">{meta.error}</div>);
    }

    if (this.props.smallDisclosure && (this.props.smallDisclosure.active || meta.active)) {
      ariaDescriptionExists = true;
      if (this.props.smallDisclosure.active) {
        smallDisclosureMarkup = (<span id={ariaDescription} className="small-disclosure active">{this.props.smallDisclosure.text}</span>);
      } else {
        smallDisclosureMarkup = (<span id={ariaDescription} className="small-disclosure">{this.props.smallDisclosure.text}</span>);
      }
    }

    return (
      <div className={parentDivStyles.join(' ')}>
        <label
          className={"label".concat(this.isDirty() ? " dirty" : "")}
          htmlFor={name}
        >
          {this.props.label}
        </label>
        <input
          id={name}
          ref={(el) => { this.ref = el; }}
          placeholder={this.props.placeholder}
          type={this.props.type}
          className={inputStyles.join(' ')}
          aria-describedby={ariaDescriptionExists ? ariaDescription : undefined}
          aria-invalid={ariaDescriptionExists}
          required={this.props.required}
          autoFocus={this.props.autoFocus}

          {...input}
          {...htmlAttributes}
          onChange={this.handleOnChange}
        />
        {errorMarkup || smallDisclosureMarkup}
      </div>);
  }
}

Input.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string.isRequired,
      PropTypes.bool.isRequired
    ])
  }),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    active: PropTypes.bool,
    error: PropTypes.string
  }),
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  type: PropTypes.string,
  label: PropTypes.string,
  smallDisclosure: PropTypes.shape({
    text: PropTypes.string.isRequired,
    active: PropTypes.bool
  })
};

export default Input;
